import {Fragment} from "react";
import {Box} from "@mui/system";
import {useDispatch} from "react-redux";
import {customFieldActions} from "_actions";
import ActionButton from "../../../../../common/ActionButton";

export default function RemoveCustomFieldContent({customFieldId, handleClose}) {
    const dispatch = useDispatch();

    const handleDeleteCustomField = () => {
        dispatch(customFieldActions.deleteCustomField(customFieldId));
        handleClose();
    }

    return (
        <Fragment>
            <Box sx={{marginTop: '-2px'}}>
                <Box sx={styles.heading}>
                    The selected custom field will be deleted
                </Box>

                <Box sx={styles.actionsContainer}>
                    <Box sx={styles.buttonContainer}>
                        <ActionButton
                            label={'Cancel'}
                            action={handleClose}
                            buttonBordered
                            useBorderColor={'#003300'}
                            withIcon={false}
                            sx={styles.cancel}
                        />
                        <ActionButton
                            label={'Delete'}
                            action={handleDeleteCustomField}
                            withIcon={false}
                            sx={styles.delete}
                        />
                    </Box>
                </Box>
            </Box>
        </Fragment>
    )
}

const styles = {
    heading: {
        fontFamily: 'LarsseitRegular',
        fontSize: '16px',
        color: '#0C2728',
        letterSpacing: '-0.01em',
        marginBottom: '12px'
    },
    buttonContainer: {
        display: 'flex',
    },
    cancel: {
        height: '35px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: '8px'
    },
    delete: {
        height: '35px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    actionsContainer: {
        display: 'flex',
        marginTop: '27px',
        justifyContent: 'flex-end'
    }
}